import { PointType } from "tm-shared/types";

import { FieldFlowMap } from "@/hooks";
import { NewPointFormValues } from "@/types/form";

// Form fields
export type FieldName = keyof NewPointFormValues;

// External ID check
export const SUCCESS_ERR_CODE_CHECK = "-32404";

// Field flow
export const FIELD_FLOW_MAP: FieldFlowMap<NewPointFormValues> = {
    title: {
        name: "title",
        deps: [],
    },
    pointType: {
        name: "pointType",
        deps: [],
    },

    partner: {
        name: "partner",
        deps: ["pointType"],
        resetDeps: ["pointType"],
        extraActiveCheck: (values) =>
            values.pointType === PointType.Distribution,
    },
    clientExternalPointId: {
        name: "clientExternalPointId",
        deps: ["partner"],
        resetDeps: ["partner"],
        extraActiveCheck: (values) =>
            values.pointType === PointType.Distribution,
    },

    region: {
        name: "region",
        deps: [],
        resetDeps: ["pointType", "partner", "clientExternalPointId"],
        extraActiveCheck: (values) =>
            values.pointType === PointType.Chains
                ? true
                : values.pointType === PointType.Distribution &&
                  !!values.partner &&
                  !!values.clientExternalPointId,
    },

    contragent: {
        name: "contragent",
        deps: ["region"],
        resetDeps: ["region"],
    },
    address: {
        name: "address",
        deps: ["contragent"],
        resetDeps: ["contragent"],
    },

    network: {
        name: "network",
        deps: ["address"],
        resetDeps: ["address"],
        extraActiveCheck: (values) => values.pointType === PointType.Chains,
    },

    storage: {
        name: "storage",
        deps: ["address"],
        resetDeps: ["address"],
        extraActiveCheck: (values) => values.pointType !== PointType.Chains,
    },
};
